import React from "react";

export interface CheckoutSegmentedTabOption<T extends string> {
  value: T;
  label: React.ReactNode;
  disabled?: boolean;
}

interface CheckoutSegmentedTabsProps<T extends string> {
  options: CheckoutSegmentedTabOption<T>[];
  value: T;
  onChange: (value: T) => void;
  className?: string;
  buttonClassName?: string;
}

const CheckoutSegmentedTabs = <T extends string>({
  options,
  value,
  onChange,
  className = "",
  buttonClassName = "",
}: CheckoutSegmentedTabsProps<T>) => (
  <div className={className}>
    {options.map((option) => (
      <button
        key={option.value}
        type="button"
        className={`${buttonClassName} ${value === option.value ? "active" : ""}`.trim()}
        disabled={option.disabled}
        onClick={() => onChange(option.value)}
      >
        {option.label}
      </button>
    ))}
  </div>
);

export default CheckoutSegmentedTabs;
